import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { env } from "@/env";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function useGoogleAnalytics() {
  const router = useRouter();
  const measurementId = env.VITE_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (!measurementId || import.meta.env.DEV) return;

    const unsubscribe = router.subscribe("onResolved", () => {
      if (typeof window.gtag !== "function") return;
      window.gtag("event", "page_view", {
        page_path: window.location.pathname + window.location.search,
        page_title: document.title,
      });
    });

    return unsubscribe;
  }, [router, measurementId]);
}
